import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCurDate, getDateString } from "../utils/DateTimeUtils";
import { RptNhanVeParamsType, TongHopReport } from "../restapi/tongHopReport";

export type ReportType = 'NhanVe' | 'ChuyenDi' | 'GiuLai' | 'LaiLo'

const initialState = {
    selectedReport: 'NhanVe' as ReportType,
    reportData: {} as any,
}
export const fetchRptNhanVe = createAsyncThunk(
    "TongHopSlice/fetchRptNhanVe",
    async (payload: RptNhanVeParamsType, { rejectWithValue }) => {
        try {

            const response = await TongHopReport.FetchNhanVe(payload)
            if (response.errorCode === 0) {
                return response;
            } else {
                return rejectWithValue(response.responseText);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);
export const TongHopSlice = createSlice({
    name: "TongHopSlice",
    initialState,
    //Khai báo các action bên trong reducers, các action để làm thay đổi state khi dispatch
    reducers: {
        updateRptDetailsData: (state, action) => {

            state.reportData = action.payload.data;
        },
        selectReport: (state, action) => {
            const { selectedReport } = action.payload;
            state.selectedReport = selectedReport;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchRptNhanVe.fulfilled, (state, action) => {
            state.selectedReport = 'NhanVe';
            state.reportData = action.payload.data;
        })
    },
});

export const { updateRptDetailsData, selectReport } = TongHopSlice.actions;
export default TongHopSlice.reducer;